"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditColumnsButton = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const react_stately_1 = require("react-stately");
const Button_1 = require("../../Button");
const OverlayTrigger_1 = require("../../internal/OverlayTrigger");
const Css_1 = require("../../../Css");
const hooks_1 = require("../../../hooks");
const inputs_1 = require("../../../inputs");
const utils_1 = require("../../../utils");
const defaultTestId_1 = require("../../../utils/defaultTestId");
function EditColumnsButton(props) {
    const { defaultOpen, disabled, columns, trigger, title, api } = props;
    const state = (0, react_stately_1.useMenuTriggerState)({ isOpen: defaultOpen });
    const buttonRef = (0, react_1.useRef)(null);
    const { menuTriggerProps } = (0, react_aria_1.useMenuTrigger)({ isDisabled: !!disabled }, state, buttonRef);
    const tid = (0, utils_1.useTestIds)(props, (0, OverlayTrigger_1.isTextButton)(trigger)
        ? (0, OverlayTrigger_1.labelOr)(trigger, "editColumnsButton")
        : (0, OverlayTrigger_1.isNavLinkButton)(trigger)
            ? (0, defaultTestId_1.defaultTestId)(trigger.navLabel)
            : (0, OverlayTrigger_1.isIconButton)(trigger)
                ? trigger.icon
                : trigger.name);
    const options = (0, react_1.useMemo)(() => columns
        // Only include options that can be hidden
        .filter((column) => column.canHide)
        // And have the `name` property defined
        .filter((column) => {
        if (!column.name || column.name.length === 0 || !column.id || column.id.length === 0) {
            console.warn("Column is missing 'name' and/or 'id' property required by the Edit Columns button", column);
            return false;
        }
        return true;
    })
        .map((column) => ({ label: column.name, value: column.id })), [columns]);
    const selectedValues = (0, hooks_1.useComputed)(() => api.getVisibleColumnIds(), [api]);
    const setSelectedValues = (0, react_1.useCallback)((ids) => {
        // Doesn't `options` already filter us to non-hidden/valid-id columns? I.e. could we just do:
        // api.setVisibleColumns(ids);
        api.setVisibleColumns(columns.filter((column) => (column.canHide ? ids.includes(column.id) : true)).map((c) => c.id));
    }, [columns, api]);
    return ((0, jsx_runtime_1.jsx)(OverlayTrigger_1.OverlayTrigger, { ...props, menuTriggerProps: menuTriggerProps, state: state, buttonRef: buttonRef, ...tid, children: (0, jsx_runtime_1.jsxs)("div", { css: {
                ...Css_1.Css.bgWhite.py5.px3.maxwPx(380).bshBasic.$,
                "&:hover": Css_1.Css.bshHover.$,
            }, children: [(0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.gray500.xsSb.mb1.ttu.$, children: title || "Select columns to show" }), (0, jsx_runtime_1.jsx)(inputs_1.CheckboxGroup, { label: title || "Select columns to show", onChange: (values) => setSelectedValues(values), values: selectedValues, options: options, columns: 2, labelStyle: "hidden" }), (0, jsx_runtime_1.jsx)("div", { css: Css_1.Css.mt1.$, children: (0, jsx_runtime_1.jsx)(Button_1.Button, { variant: "tertiary", label: "Clear selections", onClick: () => setSelectedValues([]) }) })] }) }));
}
exports.EditColumnsButton = EditColumnsButton;
